import React from 'react';


class Slide1 extends React.Component {
    constructor(props) {
        super(props);
        this.ctaButtonHandler = this.ctaButtonHandler.bind(this);
        this.state = {
        };
    }

    componentDidMount(){
        // init popovers
        $('[data-toggle="popover"]').popover();
        
        // libraries/plugins not included correctly, so mitigating against bootstrap not being fully loaded yet when popover first initialised
        setTimeout (() => {
            $('[data-toggle="popover"]').popover();          
        }, 1000);
        
        $(document).on("click", ".popover .slide3__popover-cancel", function () {
            $(this).parents(".popover").popover('hide');
        });
    }

    ctaButtonHandler() {
        const nextSlideIsOpen = document.querySelector('.slide-2') || document.querySelector('.slide-3') != null;

        if (nextSlideIsOpen) {
            this.props.journey === 1 ? this.props.custScrollTo(document.querySelector('.slide-2')) : this.props.custScrollTo(document.querySelector('.slide-3'))

        } else {
            this.props.openNextSlide()
        }
    }


    render() {
        return (
            <div className="slide slide-1">
                {/* Desktop View */}
                <div className="pres-calc__banner d-none d-sm-block">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-11 col-xl-10">
                                <div className="d-flex flex-column flex-md-row align-items-center">
                                    <h1 className="text-red flex-grow-1 font-size-24 font-size-md-28 font-size-lg-32 font-size-xl-40 font-size-xxl-44 text-right text-md-start pr-40 my-0">{this.props.journey === 1 ? this.props.data?.bannerText : this.props.data?.savingsComponent.bannerText}</h1>
                                    <img src={ this.props.journey === 1 ? this.props.data?.bannerImageUrl : this.props.data?.savingsComponent.bannerImageUrl} className="flex-grow-1 pres-calc__banner-image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container d-none d-sm-block">
                    <div className="row justify-content-center">
                        <div className="col-11 col-xl-10">
                            <h2 className="text-grey font-size-18 font-size-xl-20 font-size-xxl-24 fw-light fade-70" dangerouslySetInnerHTML={{ __html: this.props.journey === 1 ? this.props.sanitizeHTML(this.props.data?.contentTitle) : this.props.sanitizeHTML(this.props.data?.savingsComponent.contentTitle) }}></h2>
                            <p className="text-grey font-size-16 font-size-xxl-18 fw-light" dangerouslySetInnerHTML={{ __html: this.props.journey === 1 ? this.props.sanitizeHTML(this.props.data?.descriptionText) : this.props.sanitizeHTML(this.props.data?.savingsComponent.descriptionText) }}></p>
                            <button className="btn btn-primary btn-red mb-4 btn--greytext" type="button" onClick={() => this.ctaButtonHandler()}>{this.props.journey === 1 ? this.props.data?.ctaButtonText : this.props.data?.savingsComponent.ctaButtonText}</button>
                            <p className="cust-mt-6 text-grey fw-light font-size-11 lh-16 slide-1__copyright">
                                <span dangerouslySetInnerHTML={{ __html: this.props.removePtags(this.props.sanitizeHTML(this.props.data?.copyrightText)) }}></span>
                                <span data-bs-toggle="modal" data-bs-target="#infoModal" className="text-decoration-none text-link-blue hover-underline"> {this.props.data?.copyrightLink}</span>
                            </p>
                        </div>
                    </div>
                </div>

                {/* Mobile view */}
                <div className="pres-calc__banner pres-calc__banner--mobile d-flex flex-column flex-md-row align-items-center d-sm-none">
                    <h1 className="text-red flex-grow-1 font-size-24 font-size-md-32 font-size-xl-48 text-center text-md-start cust-mx-4 my-0">{this.props.journey === 1 ? this.props.data?.bannerText : this.props.data?.savingsComponent.bannerText}</h1>
                    <img src={ this.props.journey === 1 ? this.props.data?.bannerImageUrl : this.props.data?.savingsComponent.bannerImageUrl} className="flex-grow-1 pres-calc__banner-image" />
                </div>
                <div className="d-sm-none px-5">
                    <h2 className="text-grey font-size-18 font-size-xl-30 fw-light fw-xl-500 fade-70" dangerouslySetInnerHTML={{ __html: this.props.journey === 1 ? this.props.sanitizeHTML(this.props.data?.contentTitle) : this.props.sanitizeHTML(this.props.data?.savingsComponent.contentTitle) }}></h2>
                    <p className="text-grey font-size-md-18 fw-light" dangerouslySetInnerHTML={{ __html: this.props.journey === 1 ? this.props.sanitizeHTML(this.props.data?.descriptionText) : this.props.sanitizeHTML(this.props.data?.savingsComponent.descriptionText) }}></p>
                    <div className='d-flex justify-content-center '>
                        <button className="btn btn-primary btn-red mb-4" onClick={() => this.ctaButtonHandler()}>{this.props.journey === 1 ? this.props.data?.ctaButtonText : this.props.data?.savingsComponent.ctaButtonText}</button>
                    </div>
                    <p className="cust-mt-5 text-grey fw-light font-size-11 lh-20 slide-1__copyright">
                        <span dangerouslySetInnerHTML={{ __html: this.props.removePtags(this.props.sanitizeHTML(this.props.data?.copyrightText)) }}></span>
                        <span data-bs-toggle="modal" data-bs-target="#infoModal" className="text-decoration-none text-link-blue"> {this.props.data?.copyrightLink}</span></p>
                </div>
                {/* Info popup modal */}
                <div className="modal" id="infoModal" tabIndex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title font-size-18" id="infoModalLabel">Important information and assumptions</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body font-size-i-12" dangerouslySetInnerHTML={{ __html: this.props.sanitizeHTML(this.props.data?.popUpText) }}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Slide1;
